"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "niardo": {
    "ca9e0be4": [{
      "hkey": "925c2cad",
      "slug": "niardo",
      "name": "Niardo",
      "primary": true,
      "skipSearch": false
    }],
    "brendibusio": [{
      "hkey": "925c2cad",
      "slug": "niardo",
      "name": "Niardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37228617": [{
      "hkey": "925c2cad",
      "slug": "niardo",
      "name": "Niardo",
      "primary": true,
      "skipSearch": false
    }],
    "gera": [{
      "hkey": "925c2cad",
      "slug": "niardo",
      "name": "Niardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;